<div class="container">
  <div class="row">
    <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
      <div class="card card-signin my-5">
        <div class="card-body">
          <div class="text-center mb-3">
            <img src="/assets/images/ea.svg" alt="EA" width="100" />
          </div>
          <h5 class="card-title text-center">
            {{ 'navigation.title' | translate }}
          </h5>
          <security-not-found-component></security-not-found-component>
        </div>
      </div>
    </div>
  </div>
</div>
